/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import cx from 'classnames';
import PropTypes from 'prop-types';
import React__default from 'react';
import { usePrefix } from '../../internal/usePrefix.js';

var _hr;
const SideNavDivider = _ref => {
  let {
    className
  } = _ref;
  const prefix = usePrefix();
  const classNames = cx(`${prefix}--side-nav__divider`, className);
  return /*#__PURE__*/React__default.createElement("li", {
    className: classNames
  }, _hr || (_hr = /*#__PURE__*/React__default.createElement("hr", null)));
};
SideNavDivider.propTypes = {
  /**
   * Provide an optional class to be applied to the containing node
   */
  className: PropTypes.string
};

export { SideNavDivider as default };
